export const customStyles = {
    control: (base: any, state: any) => ({
        ...base,
        backgroundColor: '#262626',
        color: 'white',
        boxShadow: 'none',
        border: '0px',
        outline: 'none',
        padding: '0.5rem 0rem',
        borderRadius: '0.75rem',
    }),
    option: (base: any, state: any) => ({
        ...base,
        backgroundColor: state.isFocused ? '#3e3e3e' : 'transparent',
        color: 'white',
        fontSize: '0.9rem',
        borderBottom: `0.5px solid #484747`,
        borderLeft: '0px',
        borderRight: '0px',
        ':last-child': {
            borderBottom: '0px',
        },
        ':active': {
            ...base[':active'],
            backgroundColor: '#555555',
        },
    }),
    singleValue: (base: any) => ({
        ...base,
        color: 'white',
    }),
    menu: (base: any) => ({
        ...base,
        backgroundColor: '#262626',
        borderRadius: '0.75rem',
    }),
    menuList: (base: any) => ({
        ...base,
        padding: 0,
        backgroundImage: 'linear-gradient(#262626, black)',
        borderRadius: '0.75rem',
    }),
    placeholder: (base: any) => ({
        ...base,
        color: '#9BA3AF',
    }),
    input: (base: any) => ({
        ...base,
        color: 'white',
    }),
};